import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-step-master',
  standalone: false,
  templateUrl: './step-master.component.html',
  styleUrl: './step-master.component.scss'
})
export class StepMasterComponent implements OnInit, OnDestroy {
  title = 'Step Table';
  showDialog: boolean = false;
  viewMode: boolean = false;
  formData: any = {};
  private subscriptions = new Subscription();
  system: any[]=[]
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: 'Step Name', filterType: 'text', width: '200px', minWidth: '100px', maxWidth: '150px' },
    { field: 'code', header: 'Step Code', filterType: 'text',  width: '120px', minWidth: '100px', maxWidth: '150px'},
    { field: 'week_timeline', header: 'Timeline (in weeks)', filterType: 'text',  width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'description', header: 'Description', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },
    // { field: 'sequence', header: 'Sequence', filterType: 'text', width: '300px' },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false

  dialogConfig: DialogConfig = {
    title: 'Create Step',
    width: '60vw',
    height: 'auto',
    maximizable: true,
    closable: true,
    dismissableMask: true,
    formLayout: 'single-column',
    fields: [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Step Name',
        maxLength: 100,
        validation: {
          required: true
        }
      },
      {
        key: 'code',
        label: 'Code',
        type: 'text',
        required: true,
        placeholder: 'Enter Step Code',
        maxLength: 15,
        validation: {
          required: true
        }
      },
      {
        key: 'timeline',
        label: 'Timeline (in weeks)',
        type: 'number',
        required: false,
        placeholder: 'Enter Timeline in weeks',
        validation: {
          pattern: '^\\d+$'
        },
        patternErrorMessage: 'Please enter a valid number.'
      },
      {
        key: 'description',
        label: 'Description',
        type: 'textarea',
        required: true,
        placeholder: 'Enter Description',
        maxLength: 500,
        validation: {
          required: true
        }
      }
    ],
    submitButtonText: 'Submit',
    cancelButtonText: 'Cancel',
    showCancelButton: true
  };


  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // Initialize component
    this.getSystem();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
     const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/scheme-step/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      this.system = res.data || res.results
       this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }


  addSystem() {
    this.viewMode = false;
    this.formData = {};
    this.dialogConfig.title = 'Create Step';
    this.dialogConfig.submitButtonText = 'Submit';
    this.showDialog = true;
  }
  onSubmitStep(formData: any) {
    let payload = {
      name: formData.name,
      code: formData.code,
      sequence: formData.sequence,
      week_timeline: formData.timeline,
      description: formData.description,
      status: 1
    };
    
    if (this.selectedsystem && this.selectedsystem.id) {
      // Update existing step
      const sub = this.api.putAPI(`/master/scheme-step/${this.selectedsystem.id}/`, payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Step updated successfully'
          });
          this.showDialog = false;
          this.getSystem();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.detail || 'Failed to update step'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      // Add new step
      const sub = this.api.postAPI('/master/scheme-step/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Step submitted successfully'
          });
          this.showDialog = false;
          this.getSystem();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.name || 'Failed to add step'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  viewSystem(equipment: any) {
    this.viewMode = true;
    this.selectedsystem = equipment;
    this.dialogConfig.title = 'View Step';
    this.dialogConfig.submitButtonText = 'Close';
    this.dialogConfig.showCancelButton = false;
    
    this.formData = {
      name: equipment.name || '',
      code: equipment.code || '',
      sequence: equipment.sequence || '',
      timeline: equipment.week_timeline || '',
      description: equipment.description || '',
    };
    
    this.showDialog = true;
  }
  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.selectedsystem = equipment;
    this.dialogConfig.title = 'Update Step';
    this.dialogConfig.submitButtonText = 'Update';
    this.dialogConfig.showCancelButton = true;
    
    this.formData = {
      name: equipment.name || '',
      code: equipment.code || '',
      sequence: equipment.sequence || '',
      timeline: equipment.week_timeline || '',
      description: equipment.description || '',
    };
    
    this.showDialog = true;
  }


  onCancelDialog(): void {
    this.showDialog = false;
    this.selectedsystem = null;
    this.formData = {};
  }

  onCloseDialog(): void {
    this.showDialog = false;
    this.selectedsystem = null;
    this.formData = {};
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/scheme-step/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Step Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the proposal. Please try again.',
        });
      },
    });
  this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/step-master', 'Edit') ||
           this.permissionService.hasPrivilege('/master/step-master', 'Delete')||
           this.permissionService.hasPrivilege('/master/step-master', 'View');
  }
}
